import { API, GraphQLSubscription } from "@aws-amplify/api";
import { gql } from "graphql-tag";
import { useEffect } from "react";

import { useVolatileCallback } from "@examspark/common-ui";
import { SystemEvent } from "@examspark/types";

let observable:
  | ReturnType<
      typeof API.graphql<
        GraphQLSubscription<{ onCreateSystemEvent: SystemEvent }>
      >
    >
  | undefined;

export const useSystemEventNotifications = (
  codebaseName: string | undefined,
  callback: (e: SystemEvent) => void,
  enabled?: boolean,
) => {
  const callbackVolatile = useVolatileCallback(callback);

  useEffect(() => {
    if (!enabled) return;

    if (observable == null) {
      observable = API.graphql<
        GraphQLSubscription<{ onCreateSystemEvent: SystemEvent }>
      >({
        query: gql`
          subscription OnCreateSystemEvent {
            onCreateSystemEvent {
              type
              codebaseName
              data
              __typename
            }
          }
        `,
        authMode: "API_KEY",
      });
    }

    const subscription = observable.subscribe({
      next: ({ value }) => {
        const e = value.data?.onCreateSystemEvent;
        if (e == null) return;
        if (
          e.codebaseName != null &&
          codebaseName != null &&
          e.codebaseName !== codebaseName
        ) {
          return;
        }

        callbackVolatile(e);
      },
    });

    return () => {
      if (subscription != null) {
        subscription.unsubscribe();
      }
    };
  }, [codebaseName, callbackVolatile, enabled]);
};
